<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('association.keys.keys_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="update-activation-keys-submit"
                :loading="processing"
                @click="handleSubmit"
            >
                {{ $t('association.keys.keys_modal.submit') }}
            </a-button>
        </template>
        <div class="input-container mb-2" data-cy="update-activation-keys-new-expiry-date">
            <ui-label>{{ $t('association.keys.keys_modal.new_expiry_date') }}</ui-label>
            <ui-date-picker v-model="expiry_date" :disableDateFunction="disableDate" />
        </div>
    </a-modal>
</template>

<script>
import UiDatePicker from '@/components/ui/DatePicker.vue';
import UiLabel from '@/components/ui/Label.vue';

export default {
    components: { UiDatePicker, UiLabel },
    data() {
        return {
            modal_visible: false,
            is_reactivation: null,
            expiry_date: this.$dayjs().add(1, 'day'),
            disableDate: (current) => {
                var today = new this.$dayjs();
                return current.isBefore(today);
            },
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
